import styled from 'styled-components';
import Link from 'gatsby-link';

import { mobile } from '../../../utils/breakpoints';
import {
  red, lighterBlue, grey, tekoLight,
} from '../../../utils/theme';

export const ShareLink = styled(Link)`
  border: 2px solid ${lighterBlue};
  color: ${lighterBlue};
  ${tekoLight} font-size: 29px;
  font-weight: normal;
  letter-spacing: 3px;
  padding: 10px 15px;
  text-transform: none;

  .button-red {
    color: ${red};
  }

  @media (max-width: ${mobile.max}px) {
    border: none;
    margin: 0;
  }
`;

export const ShareLinkWrapper = styled.div`
  border-left: 1px solid ${grey};
  margin: 0 0 0 15px;
  padding: 0 30px;
`;



// WEBPACK FOOTER //
// ./src/components/share/styles/share-link.style.js